import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { RovoAgentsPluginState } from './states';

export const rovoAgentsPluginKey = new PluginKey<RovoAgentsPluginState>('rovoAgentsPlugin');
